import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_LOCATION_FOR_PROVIDER } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../../providerPayRequestDashboard/utils/constants";

/* Locations the provider can raise a pay request against. */
export const getLocationsForProvider = async (cookiesData, dispatch, providerId) => {
  if (!cookiesData || !providerId) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_provider_id: providerId,
      in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
    };

    const response = await POSTAPI(false, GET_LOCATION_FOR_PROVIDER, null, apiHeaders, requestBody, dispatch);
    const rowResult = response?.data?.row_result;

    return Array.isArray(rowResult) ? rowResult : [];
  } catch (error) {
    console.error("Error fetching locations for provider:", error);
    return [];
  }
};
